import {createSelector} from 'reselect'
import {isDemoVersion} from '../constants'
import {LicenseManagerStatus, licensesType, SHOW_COUNTDOWN_TIP_LICENSE_DAYS_TO_EXPIRATION} from './constants'

const getActiveLicenseInfoState = state => state.activeLicenseInfo

export const getLicenseCountDaysToExpiration = createSelector(
    getActiveLicenseInfoState,
    (activeLicenseInfo) => activeLicenseInfo.daysToExpiration
)

export const loggedInUserCanManageLicenses = createSelector(
    getActiveLicenseInfoState,
    (activeLicenseInfo) => activeLicenseInfo.licenseManagerStatus === LicenseManagerStatus.ACTIVE
                           || activeLicenseInfo.licenseManagerStatus === LicenseManagerStatus.PREDEFINED
)

export const isShowLicenseCountDownTip = createSelector(
    getActiveLicenseInfoState,
    loggedInUserCanManageLicenses,
    (activeLicenseInfo, canManageLicense) => {
        return !isDemoVersion && canManageLicense
               && activeLicenseInfo.daysToExpiration > 0
               && activeLicenseInfo.daysToExpiration <= SHOW_COUNTDOWN_TIP_LICENSE_DAYS_TO_EXPIRATION
               && !activeLicenseInfo.thereARenewal
    }
)

export const isLicenseExpired = createSelector(
    getActiveLicenseInfoState,
    state => state.daysToExpiration === 0
)

export const isOtherProductLicenseExpired = createSelector(
    getActiveLicenseInfoState,
    state => state.otherProductExpired
)

export const isLicenseFree = createSelector(
    getActiveLicenseInfoState,
    (activeLicenseInfo) => activeLicenseInfo.type === licensesType.FREE
)

export const isLicenseViolated = createSelector(
    getActiveLicenseInfoState,
    (activeLicenseInfo) => activeLicenseInfo.violated
)

export const isOtherProductLicenseViolated = createSelector(
    getActiveLicenseInfoState,
    (activeLicenseInfo) => activeLicenseInfo.otherProductViolated
)

export const wasOtherProductEverIntegrated = createSelector(
    getActiveLicenseInfoState,
    (activeLicenseInfo) => activeLicenseInfo.wasOtherProductEverIntegrated
)

export const currentUsedUserCount = createSelector(
    getActiveLicenseInfoState,
    (activeLicenseInfo) => activeLicenseInfo.userCounters.actualCount
)



// WEBPACK FOOTER //
// ./web/js/activeLicenseInfo/selectors.js